import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WkCommentsTabComponent } from './wk-comments-tab.component';
import { CoreModule } from '@alfresco/adf-core';
import { MaterialModule } from '../../../material.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@alfresco/aca-shared';
import { WkTabsHoverAnimationDirective } from '../directives/wk-tabs-hover-animation/wk-tabs-hover-animation.directive';
import { UmcSentenceCasePipe } from '../../../pipes/umc-sentence-case.pipe';
@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    RouterModule,
    MaterialModule,
    TranslateModule,
    SharedModule,
    WkTabsHoverAnimationDirective,
  ],
  declarations: [WkCommentsTabComponent, UmcSentenceCasePipe],
  exports: [WkCommentsTabComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WkCommentsTabModule {}
